import React, {useState} from 'react';

import Tooltip from './Tooltip';
import {DuplicateIcon, SimpleCheckIcon} from './svg';

const CopyButton = ({value, onClick, ...props}) => {
  const [copied, setCopied] = useState(false);

  const onClickCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
    onClick?.();
  };

  return copied ? (
    <Tooltip content="Copied" placement="right">
      <button type="button" onClick={onClickCopy} aria-label="Copied" {...props}>
        <SimpleCheckIcon className="h-5 w-5 text-green-400" />
      </button>
    </Tooltip>
  ) : (
    <Tooltip content="Copy to clipboard" placement="right">
      <button type="button" onClick={onClickCopy} aria-label="Copy to clipboard" {...props}>
        <DuplicateIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
      </button>
    </Tooltip>
  );
};

export default CopyButton;
